"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.clear.messages': 'Limpiar Mensajes',
};
